module.exports = __webpack_public_path__ + "img/Réalisation structure hamac.6a45738d.jpg";